export default __webpack_public_path__ + "static/media/envolpe.c60abcdc.svg";